import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack } from '@chakra-ui/react'
import { DefaultContactForm } from '../../../../components/secure/contacts/DefaultContactForm'
import { history } from '../../../../ApplicationRouter'

export const CreateDefaultContact = () => {
  return (
    <AutoWidthCenter>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">Create default contact</Heading>
          <Button onClick={() => history.back()}>Back</Button>
        </HStack>
        <Divider />
        <DefaultContactForm />
      </Box>
    </AutoWidthCenter>
  )
}